module.exports = __webpack_public_path__ + "assets/icon-animalType-rabbit.23c276fe.svg";